import React, { useState, useEffect } from "react";
import ReactDOM from 'react-dom';


const Clients = () => {

  return (
    <>
      {/*==========================
    Clients Section
  ============================*/}
      <section id="clients" className="section-bg">
        <div className="container">
          <div className="section-header">
            <h3>Our Clients</h3>
            <p style={{ color: "red" }}>
              As a new startup, integrity is our foundation. While we're eager
              to earn the trust of our future clients, we currently don't have
              client information to share publicly. We apologize for any
              inconvenience this may cause. However, you can find testimonials
              from our clients in the testimonial section above. We encourage
              you to refer to those for more information.
            </p>
          </div>

          {/* <div className="row no-gutters clients-wrap clearfix wow fadeInUp">
            <div className="col-lg-3 col-md-4 col-xs-6">
              <div className="client-logo">
                <img
                  src="img/clients/client-1.png"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>

            <div className="col-lg-3 col-md-4 col-xs-6">
              <div className="client-logo">
                <img
                  src="img/clients/client-2.png"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>

            <div className="col-lg-3 col-md-4 col-xs-6">
              <div className="client-logo">
                <img
                  src="img/clients/client-3.png"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>

            <div className="col-lg-3 col-md-4 col-xs-6">
              <div className="client-logo">
                <img
                  src="img/clients/client-4.png"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>

            <div className="col-lg-3 col-md-4 col-xs-6">
              <div className="client-logo">
                <img
                  src="img/clients/client-5.png"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>

            <div className="col-lg-3 col-md-4 col-xs-6">
              <div className="client-logo">
                <img
                  src="img/clients/client-6.png"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>

            <div className="col-lg-3 col-md-4 col-xs-6">
              <div className="client-logo">
                <img
                  src="img/clients/client-7.png"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>

            <div className="col-lg-3 col-md-4 col-xs-6">
              <div className="client-logo">
                <img
                  src="img/clients/client-8.png"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
          </div> */}
        </div>
      </section>
    </>
  );
};

export default Clients;